var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-conteudo"},[_c(_setup.TabelaDeContasAPagar,{attrs:{"controlesDesativados":_setup.props.controlesDesativados,"dado":_setup.props.dado},on:{"update:alteraContasAPagar":_setup.alteraContasAPagar,"update:alteraContaAPagar":_setup.alteraContaAPagar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }